import { navigate } from "gatsby"
import React from "react"
import { render } from "react-dom"

import { ListingCard } from "../../../cards"
import { iPageExcerpt } from "../../../types"
import { iPrevNextArticle } from "../../../types"
import { ContentSeparator } from "../../Utils/ContentSeparator"
import { ContentHeadingView } from "../ContentHeading"
import NextItem from "./NextItem"

const renderNextItems = (articles: iPrevNextArticle[]) =>
  articles.map((article, i) => {
    return <NextItem key={i.toString()} {...article.node} />
  })

interface Props {
  items: iPrevNextArticle[]
}

const NextArticle: React.FC<Props> = props => {
  return <div>{renderNextItems(props.items)}</div>
}

export default NextArticle
